<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-lg-7 col-md-10">
            <p class="text-white mt-3 mb-5">
              Aqui você confere todas as avaliações realizadas pelos
              investidores para as startups inscritas na chamada. Toda nova
              avaliação aparecerá automaticamente na tabela abaixo.
            </p>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--8">
      <div class="row">
        <div class="col">
          <div
            class="card shadow table-container vld-parent"
            ref="avaliacoes_table"
          >
            <div class="card-header border-0">
              <div class="row align-items-center">
                <div class="col">
                  <h3 class="mb-0">
                    Avaliação das startups
                    <span v-if="evaluation.startupCall"
                      >da chamada
                      <span class="text-warning">{{
                        evaluation.startupCall.name
                      }}</span>
                      <router-link
                        :to="`/admin/chamadas/${evaluation.startup_call_id}/avaliacao`"
                      >
                        <i class="ml-2 fas fa-eye fa-sm"></i> </router-link
                    ></span>
                  </h3>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <base-table
                class="table align-items-center table-flush"
                thead-classes="thead-light"
                tbody-classes="list"
                :data="responses"
              >
                <template slot="columns">
                  <th>Data</th>
                  <th>Investidor</th>
                  <th>Startup</th>
                  <th>Recomenda inv.</th>
                  <th>Notas da avaliação</th>
                  <th>Comentário</th>
                </template>
                <template slot-scope="{ row }">
                  <td>
                    <span>{{ formatDate(row.updated_at) }}</span>
                  </td>
                  <td>
                    <router-link
                      :to="`/admin/investidores/${row.investor_id}/editar`"
                      class="btn btn-link pl-0"
                    >
                      {{ row.investor_name }}
                    </router-link>
                  </td>
                  <td>
                    <router-link
                      :to="`/admin/chamadas/${evaluation.startup_call_id}/inscricoes/${row.subscription_id}`"
                      class="btn btn-link pl-0"
                    >
                      {{ row.startup_name }}
                    </router-link>
                  </td>
                  <td>
                    {{
                      row.advise_investiment === null
                        ? "Neutro"
                        : row.advise_investiment
                        ? "Sim"
                        : "Não"
                    }}
                  </td>
                  <td>
                    <span
                      :title="getTitle(answer.question_id)"
                      v-for="answer in row.answers"
                      @click="
                        handleShowQuestion(
                          answer.question_id,
                          answer.stars,
                          row.investor_name,
                          row.startup_name
                        )
                      "
                      :key="'answer_' + answer.id"
                      class="btn-link bg-white rounded border p-2 mr-1 d-inline-flex align-items-center"
                      >{{ answer.stars
                      }}<i class="ml-1 fas fa-star text-sm text-warning"></i
                    ></span>
                  </td>
                  <td>
                    <span
                      v-if="row.comment"
                      class="btn btn-link p-0"
                      @click="
                        handleShowComment(
                          row.comment,
                          row.investor_name,
                          row.startup_name
                        )
                      "
                      >Exibir <i class="fas fa-comment-dots"></i
                    ></span>
                    <span v-else>N/A</span>
                  </td>
                </template>
              </base-table>
              <p v-if="empty" class="text-center text-warning mt-3">
                Não há avaliações para as startups inscritas na chamada até o
                momento
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal
      :show.sync="modalQuestion.showModal"
      modal-classes="modal-dialog-centered"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Avaliação
      </h6>
      <div class="py-3 text-center">
        <i class="fa fa-question-circle fa-2x"></i>
        <h4 class="heading mt-4">
          {{ modalQuestion.question.title }}
        </h4>
        <p class="mt-3 mb-0 text-muted">
          {{ modalQuestion.question.description }}
        </p>
        <p class="mt-3 mb-1">
          Nota para a startup
          <span class="text-warning">{{ modalQuestion.startupName }}</span>
        </p>
        <p>
          <span
            v-for="(star, index) in modalQuestion.stars"
            :key="'modal_star_check_' + index"
          >
            <i class="fas fa-star text-warning"></i>
          </span>
          <span
            v-for="(star, index) in 5 - modalQuestion.stars"
            :key="'modal_star_empty_' + index"
          >
            <i class="fas fa-star text-gray"></i>
          </span>
          ({{ modalQuestion.stars }}/5)
        </p>
        <p class="text-right">
          <span class="text-warning">{{ modalQuestion.investorName }}</span
          >, investidor STARS
        </p>
      </div>
      <template slot="footer">
        <base-button
          type="link"
          class="ml-auto"
          @click="modalQuestion.showModal = false"
        >
          Fechar
        </base-button>
      </template>
    </modal>
    <modal
      :show.sync="modalComment.showModal"
      modal-classes="modal-default modal-dialog-centered"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Avaliação
      </h6>
      <div class="py-3 text-center">
        <i class="fa fa-comment-dots fa-2x"></i>
        <h4 class="heading mt-4">
          Comentário para a startup
          <span class="text-warning">{{ modalComment.startupName }}</span>
        </h4>
        <p class="mt-3 mb-0">
          <i class="fas fa-quote-left mr-1"></i>{{ modalComment.comment
          }}<i class="fas fa-quote-right ml-1"></i>
        </p>
        <p class="text-right mt-1">
          <span class="text-warning">{{ modalComment.investorName }}</span
          >, investidor STARS
        </p>
      </div>
      <template slot="footer">
        <base-button
          type="link"
          text-color="white"
          class="ml-auto"
          @click="modalComment.showModal = false"
        >
          Fechar
        </base-button>
      </template>
    </modal>
  </div>
</template>
<script>
import api from "@/services/api";

export default {
  name: "respostas_table",
  data() {
    return {
      evaluation: "",
      responses: [],
      empty: false,
      modalQuestion: {
        showModal: false,
        investorName: "",
        startupName: "",
        stars: 0,
        question: {
          title: "",
          description: "",
        },
      },
      modalComment: {
        showModal: false,
        comment: "",
        investorName: "",
        startupName: "",
      },
    };
  },
  async mounted() {
    const loader = this.$loading.show({
      container: this.$refs.avaliacoes_table,
      width: 90,
      height: 90,
    });
    try {
      const {
        data: { evaluation, responses },
      } = await api.get(`/adm/evaluations/${this.$route.params.id}`);
      this.responses = responses;
      this.evaluation = evaluation;
      evaluation.updated_at = this.formatDate(evaluation.updated_at);
      if (evaluation && responses.length) {
        this.evaluation = evaluation;
        this.responses = responses;
      } else this.empty = true;

      loader.hide();
    } catch (e) {
      this.$toasted.error("Ocorreu um erro ao recuperar as informações");
    }
  },
  methods: {
    handleShowQuestion(questionId, stars, investorName, startupName) {
      const questions = this.evaluation.evaluationQuestions;
      const matches = questions.filter((q) => q.id === questionId);
      if (matches.length) {
        const targetQuestion = matches[0];
        this.modalQuestion.question.title = targetQuestion.title;
        this.modalQuestion.question.description = targetQuestion.description;
        this.modalQuestion.stars = Number(stars);
        this.modalQuestion.investorName = investorName;
        this.modalQuestion.startupName = startupName;
        this.modalQuestion.showModal = true;
      }
    },
    getTitle(questionId) {
      const questions = this.evaluation.evaluationQuestions;
      const matches = questions.filter((q) => q.id === questionId);
      if (matches.length) return matches[0].title;
      return "Pergunta inválida";
    },
    handleShowComment(comment, investorName, startupName) {
      this.modalComment.comment = comment;
      this.modalComment.investorName = investorName;
      this.modalComment.startupName = startupName;
      this.modalComment.showModal = true;
    },
  },
  computed: {
    truncate(text, stop = 50, clamp) {
      if (!clamp && text.slice(-1) !== ".") clamp = ".";
      return (
        text.slice(0, stop) + (stop < text.length ? clamp || "..." : clamp)
      );
    },
  },
};
</script>
<style scoped>
.table-container {
  min-height: 150px;
}
</style>
